import { HEX_COLORS as i } from "@partoohub/branding";
import { ChartType as o } from "../../types/components/chart.js";
const d = (e) => {
  switch (e) {
    case o.Bar:
      return r();
    case o.Doughnut:
      return n();
    case o.Line:
      return a;
    case o.Quadrant:
      return s();
    default:
      return {};
  }
}, r = (e = !0) => ({
  datasets: {
    bar: {
      borderRadius: {
        topRight: 4,
        topLeft: 4
      },
      borderSkipped: "middle"
    }
  },
  interaction: {
    mode: "index",
    intersect: !1
  },
  plugins: {
    tooltip: {
      backgroundColor: i.blackberry
    },
    legend: {
      display: !0,
      position: "bottom",
      labels: {
        boxWidth: 13,
        padding: 15,
        fontSize: 12,
        useBorderRadius: !0,
        borderRadius: 4,
        font: {
          size: 12,
          weight: 600
        },
        color: i.secondary
      },
      onHover: (t) => {
        t.native.target.style.cursor = "pointer";
      },
      onLeave: (t) => {
        t.native.target.style.cursor = "default";
      }
    }
  },
  scales: {
    x: {
      stacked: e,
      grid: {
        display: !1,
        drawBorder: !0
      }
    },
    y: {
      stacked: e,
      beginAtZero: !0,
      min: 0,
      ticks: {
        callback(t) {
          return t % 1 === 0 ? t : null;
        }
      }
    }
  },
  hover: {
    onHover: (t) => {
      t.native.target.style.cursor = "auto";
    }
  },
  maintainAspectRatio: !1,
  responsive: !0
}), n = () => ({
  plugins: {
    legend: {
      display: !1
    },
    tooltip: {
      enabled: !1
    }
  },
  animation: {
    duration: 200,
    easing: "linear"
  },
  aspectRatio: 1,
  maintainAspectRatio: !1,
  responsive: !0
}), a = {
  interaction: {
    mode: "index",
    intersect: !1
  },
  scales: {
    x: {
      grid: {
        display: !1
      },
      ticks: {
        font: {
          size: 12
        }
      }
    },
    y: {
      grid: {
        display: !1
      },
      beginAtZero: !0,
      ticks: {
        font: {
          size: 12
        }
      }
    }
  },
  plugins: {
    tooltip: {
      backgroundColor: i.blackberry
    },
    legend: {
      display: !0,
      position: "bottom",
      labels: {
        boxWidth: 13,
        padding: 15,
        usePointStyle: !0,
        pointStyle: "rectRounded",
        font: {
          size: 12,
          weight: 600
        },
        color: i.secondary
      },
      onHover: (e) => {
        e.native.target.style.cursor = "pointer";
      },
      onLeave: (e) => {
        e.native.target.style.cursor = "default";
      }
    }
  },
  aspectRatio: 1,
  maintainAspectRatio: !1,
  responsive: !0
}, s = () => ({
  scales: {
    x: {
      type: "linear",
      position: "center",
      display: !1
    },
    y: {
      type: "linear",
      position: "center",
      display: !1
    }
  },
  plugins: {
    tooltip: {
      backgroundColor: i.blackberry
    },
    legend: {
      display: !1
    }
  },
  maintainAspectRatio: !1
});
export {
  d as buildOptionsForGraphic,
  n as doughnutGraphicOptions,
  a as newLineGraphicOptions,
  s as quadrantGraphicOptions,
  r as verticalGraphicOptions
};
